var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_5381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05859 8.30765C1.05859 5.4067 1.05859 3.95623 2.01282 3.05502C2.96704 2.15381 4.50284 2.15381 7.57443 2.15381H10.8323C13.9039 2.15381 15.4397 2.15381 16.394 3.05502C17.3482 3.95623 17.3482 5.4067 17.3482 8.30765V9.84612C17.3482 12.7471 17.3482 14.1975 16.394 15.0988C15.4397 16 13.9039 16 10.8323 16H7.57443C4.50284 16 2.96704 16 2.01282 15.0988C1.05859 14.1975 1.05859 12.7471 1.05859 9.84612V8.30765Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13086 2.15385V1",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2759 2.15385V1",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46582 6H16.9409",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_5381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatepicker);
export default __webpack_public_path__ + "static/media/icon_datepicker.055e2d2caa5bb7c3182be3786a662e36.svg";
export { ForwardRef as ReactComponent };